module.exports = __webpack_public_path__ + "static/img/10.11be3e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/10.png
// module id = 127
// module chunks = 2